import { Dispatch } from 'redux';

import ReservationService from '~/services/ReservationService';
import VendorsService from '~/services/VendorsService';

export const FETCH_RATE_PLANS_REQUEST = 'FETCH_RATE_PLANS_REQUEST';
export const FETCH_RATE_PLANS_SUCCESS = 'FETCH_RATE_PLANS_SUCCESS';
export const FETCH_RATE_PLANS_FAILURE = 'FETCH_RATE_PLANS_FAILURE';

export const fetchRatePlansRequest = () => ({
  type: FETCH_RATE_PLANS_REQUEST,
});

export const fetchRatePlansSuccess = (payload: {
  ratePlans: Array<App.RatePlan>;
  total: number;
  vendorNames: Record<string, string>;
}) => ({
  type: FETCH_RATE_PLANS_SUCCESS,
  payload,
});

export const fetchRatePlansFailure = (error: string) => ({
  type: FETCH_RATE_PLANS_FAILURE,
  payload: error,
});

export const fetchPaginatedRatePlans =
  (source: string, page?: number, limit?: number, orderByField?: string, orderByDirection?: string) =>
  async (dispatch: Dispatch) => {
    dispatch(fetchRatePlansRequest());

    try {
      const response = await ReservationService.getRatePlansBySource(
        source,
        page,
        limit,
        orderByField,
        orderByDirection,
      );
      const ratePlans = response.result || [];
      const total = response.total || 0;

      const uniqueVendorIds = [...new Set(ratePlans.map((plan: any) => plan.id_salesforce_external))] as Array<string>;

      const vendorResponses = await Promise.allSettled(uniqueVendorIds.map((id) => VendorsService.getVendorById(id)));

      const vendorNames: Record<string, string> = {};
      vendorResponses.forEach((result, vendorId) => {
        if (result.status === 'fulfilled' && result.value.result?.name) {
          vendorNames[uniqueVendorIds[vendorId]] = result.value.result.name;
        }
      });

      dispatch(fetchRatePlansSuccess({ ratePlans, total, vendorNames }));
    } catch (error: any) {
      console.error('Failed to fetch rate plans:', error);
      dispatch(fetchRatePlansFailure(error));
    }
  };
